<li class="item-avis bg-white shadow my-4">
    <div class="top-avis row p-3">
        <div class="col-12 d-flex align-items-center">
            <h2 class="summary-avis h4">{{ avis.summary }}</h2>
        </div>
    </div>
    <div class="container-avis p-3">
        <div class="top-container-avis d-flex justify-between mb-3">
            <div class="author-avis fst-italic">{{ avis.job }}</div>
            <div class="mark-avis">
                <i class="bi"
                    [ngClass]="{
                        'bi-star-fill': avis.note >= 1,
                        'bi-star': avis.note < 1
                    }">
                </i>
                <i class="bi bi-star-fill"
                    [ngClass]="{
                        'bi-star-fill': avis.note >= 2,
                        'bi-star': avis.note < 2
                    }">
                </i>
                <i class="bi"
                    [ngClass]="{
                        'bi-star-fill': avis.note >= 3,
                        'bi-star': avis.note < 3
                    }">
                </i>
                <i class="bi"
                    [ngClass]="{
                        'bi-star-fill': avis.note >= 4,
                        'bi-star': avis.note < 4
                    }">
                </i>
                <i class="bi"
                    [ngClass]="{
                        'bi-star-fill': avis.note >= 5,
                        'bi-star': avis.note < 5
                    }">
                </i>
            </div>
        </div>
        <div class="content-avis" [innerHtml]="getShortContent()"></div>
        <div class="bottom-avis">
            <div class="mt-3 text-end">{{ avis.author }} 
                <span *ngIf="avis.age !== null" class="age">
                    {{ avis.age }} ans
                </span>
            </div>
        </div>
        <div class="voir-plus">
            <!-- Button trigger modal -->
            <button type="button" class="btn btn-sm" data-bs-toggle="modal" [attr.data-bs-target]="'#exampleModall'+avis.id">
                voir plus
            </button>
            <!-- Modal -->
            <div class="modal fade" [id]="'exampleModall'+avis.id" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title" id="exampleModalLabel">{{avis.author}}</h3>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body" [innerHtml]="avis.content"></div>
                        <div class="modal-footer">
                            <button type="button" class="btn" data-bs-dismiss="modal">Retour</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</li>
